module.exports = __webpack_public_path__ + "img/dead.222a7c3d.png";